var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
var MockProxy = /** @class */ (function () {
    function MockProxy(getDataOrConfig, delayTimeout) {
        this.params = {};
        if (typeof getDataOrConfig === 'object') {
            this.name = getDataOrConfig.name;
            this.getData = getDataOrConfig.getData || (function () { return ({ ok: true }); });
            this.delay = typeof getDataOrConfig.delay === 'number' ? getDataOrConfig.delay : 1000;
            this.logRequest =
                getDataOrConfig.logRequest === undefined ? true : !!getDataOrConfig.logRequest;
        }
        else {
            this.getData = getDataOrConfig;
            this.delay = typeof delayTimeout === 'number' ? delayTimeout : 1000;
            this.logRequest = false;
            this.name = '';
        }
    }
    MockProxy.prototype.load = function (payload, loadParams) {
        var params = __assign(__assign({}, this.params), (loadParams || {}));
        if (this.logRequest) {
            console.info("[MockProxy " + (this.name || 'unknown') + "] load with params " + JSON.stringify(params) + " and payload: " + JSON.stringify(payload || {}));
        }
        return of({
            data: this.getData(params, payload),
            meta: { status: 200 }
        }).pipe(delay(this.delay));
    };
    /**
     * Set data provider
     */
    MockProxy.prototype.setDataProvider = function (dataProvider) {
        this.getData = dataProvider;
    };
    MockProxy.prototype.setParams = function (params) {
        this.params = params;
    };
    return MockProxy;
}());
export { MockProxy };
//# sourceMappingURL=MockProxy.js.map